import { workAnnualProxy, workAnnualProxyBody } from './index';
// workAnnualProxy: proxy/work/annual/
// workAnnualProxyBody: proxyBody/work/annual/

// 연차사용계획작성 일자 체크
function checkAnnualPlanDet(params) {
  return workAnnualProxy.get('plan/app/1.0/check', {
    params,
  });
}

// 연차사용계획작성 년도 조회
function getAnnualPlanYearList(params) {
  return workAnnualProxy.get('plan/app/1.0/year/list', {
    params,
  });
}

// 연차사용계획작성 년도 조회
function getAnnualPlanYearInfo(params) {
  return workAnnualProxy.get('plan/app/1.0/year/info', {
    params,
  });
}

// 연차사용계획작성 목록 조회
function getAnnualPlanList(params) {
  return workAnnualProxy.get('plan/app/1.0/list', {
    params,
  });
}

// 연차사용계획작성 목록 조회
function postAnnualPlan(params) {
  return workAnnualProxyBody.post('plan/app/1.0/save', params);
}

// 연차사용계획작성 삭제
function deleteAnnualPlan(params) {
  return workAnnualProxyBody.post('plan/app/1.0/delete', params);
}

// 연차사용계획작성 제출
function postAnnualPlanFinish(params) {
  return workAnnualProxyBody.post('plan/app/1.0/fin/save', params);
}

export {
  checkAnnualPlanDet,
  getAnnualPlanYearList,
  getAnnualPlanList,
  getAnnualPlanYearInfo,
  postAnnualPlan,
  deleteAnnualPlan,
  postAnnualPlanFinish,
};
